import { getRequest } from 'utils/api/apiRequest'
import { Category } from 'utils/api/Categories/fetchCategories'

export const fetchSubCategories = (id: number, lang: string) =>
  getRequest<{ subcategories: Category[] }>(
    `/redemption-site/categories/${id}/subcategories?sort[code]=asc&limit=1000&lang=en`
  )
